<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 16 17">
    <path
      d="M0.0439453 15.1846C0.0439453 14.6978 0.438525 14.3033 0.925264 14.3033H15.0264C15.5131 14.3033 15.9077 14.6978 15.9077 15.1846C15.9077 15.6713 15.5131 16.0659 15.0264 16.0659H0.925265C0.438526 16.0659 0.0439453 15.6713 0.0439453 15.1846Z"
      :class="colorClass"
    />

    <path
      d="M11.0569 9.89666H4.89473L3.70621 12.8679C3.57237 13.2025 3.24832 13.4219 2.88795 13.4219C2.26447 13.4219 1.83814 12.7922 2.06969 12.2133L6.8729 0.756153C7.00674 0.421553 7.33081 0.202148 7.69118 0.202148H8.26046C8.62083 0.202148 8.9449 0.421554 9.07874 0.756154L13.8819 12.2133C14.1135 12.7922 13.6872 13.4219 13.0637 13.4219C12.7033 13.4219 12.3793 13.2025 12.2454 12.8679L11.0569 9.89666ZM10.3519 8.13402L7.97582 2.74475L5.59978 8.13402H10.3519Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
